import { useFloatingContext, FloatingWrapper } from '@elliemae/ds-floating-context';
import { styled } from '@elliemae/ds-system';
import React from 'react';
import {
  ControlledDateTimePickerDatatestid,
  DSControlledDateTimePickerName,
  DSControlledDateTimePickerSlots,
} from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { TimeWheelContent } from './TimeWheelContent.js';
import { TimeWheelContext } from './TimeWheelContext.js';

const StyledFloatingWrapper = styled(FloatingWrapper, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.CONTEXTUAL_MENU.TIMEWHEEL,
})``;

export const TimeWheelWrapper = () => {
  const { referenceElement, closeTimePicker } = React.useContext(TimeWheelContext);
  const { isControllerOnly, getProps } = React.useContext(ControlledDateTimePickerContext);

  const {
    refs,
    floatingStyles,
    context,
    isOpen: isFloatingOpen,
  } = useFloatingContext({
    externallyControlledIsOpen: !isControllerOnly && !!referenceElement,
    externalReferenceElement: referenceElement,
    withoutAnimation: true,
    customOffset: [0, 0],
    onClickOutside: isControllerOnly ? undefined : closeTimePicker,
  });

  if (isControllerOnly) return <TimeWheelContent />;
  if (!referenceElement) return null;

  return (
    <StyledFloatingWrapper
      innerRef={refs.setFloating}
      isOpen={isFloatingOpen}
      floatingStyles={floatingStyles}
      context={context}
      data-testid={ControlledDateTimePickerDatatestid.CONTEXTUAL_MENU.TIMEWHEEL}
      getOwnerProps={getProps}
      aria-label="time wheel header"
      role="dialog"
    >
      <TimeWheelContent />
    </StyledFloatingWrapper>
  );
};
